import React from 'react'

import UsersList from '../components/Users/UsersList'
import GroupsList from 'components/Groups/GroupsList'

export default class Users extends React.Component {
  state = {
    activeTab: 'users',
  }

  /**
   * @param {String} activeTab
   */
  handleChangeTab = activeTab => {
    this.setState({ activeTab })
  }

  render() {
    const { activeTab } = this.state

    return (
      <>
        <div className='tabs'>
          <div
            className={`tabs__tab${
              activeTab === 'users' ? ' tabs__tab--active' : ''
            }`}
            onClick={() => this.handleChangeTab('users')}>
            Все сотрудники
          </div>
          <div
            className={`tabs__tab${
              activeTab === 'users-groups' ? ' tabs__tab--active' : ''
            }`}
            onClick={() => this.handleChangeTab('users-groups')}>
            Группы сотрудников
          </div>
        </div>

        {activeTab === 'users' && <UsersList />}
        {activeTab === 'users-groups' && <GroupsList />}
      </>
    )
  }
}
